// This file is to eventually replace the current line graph using dygraphs

import React, { useRef, useState } from 'react';
import { LINE_CHART_CONTEXT, TOTAL_VALUE } from './constants';
import Graph from './graph';
import { InfoPanel } from './InfoPanel/InfoPanel';

// example data structure
/*
[
    {
        x: [1, 2, 3],
        y: [2, 6, 3],
        type: 'scatter',
        mode: 'lines+markers',
    },
]
*/
// colors - array of line colors
// layout - any additional layout properties or overwrite default

const Plotly = ({
  aggregate,
  data,
  colors,
  title,
  xlabel,
  ylabel,
  layout,
  loading,
  onUpdate,
  onRelayout,
  onInitialized,
  onAfterPlot,
  onLegendClick,
  onLegendDoubleClick,
  maxY,
  darkTheme,
}) => {
  const container = useRef(null);
  const [clickedFeature, setClickedFeature] = useState({});

  const onClick = data => {
    let label = '';
    const enableInfoOnClick = !!data.points[0]?.data?.enableInfoOnClick;
    if (enableInfoOnClick) {
      for (let i = 0; i < data.points.length; i++) {
        label = data.points[i].data.text;
      }

      if (label !== '' && label !== TOTAL_VALUE) {
        setClickedFeature({ label });
      }
    }
  };

  return (
    <div ref={container} style={{ width: '100%', height: '100%' }}>
      <Graph
        data={data}
        layout={{
          colorway: colors ? colors : null,
          annotations: [
            {
              xref: 'paper',
              yref: 'paper',
              x: 1,
              xanchor: 'right',
              y: 1,
              yanchor: 'bottom',
              text: 'Source: Welligence Energy Analytics',
              showarrow: false,
              font: {
                color: 'lightgrey',
                size: 10,
              },
            },
          ],
          ...layout,
        }}
        config={{
          modeBarButtonsToRemove: [
            'pan2d',
            'select2d',
            'lasso2d',
            'zoomIn2d',
            'zoomOut2d',
            'autoScale2d',
          ],
        }}
        title={title}
        xlabel={xlabel}
        ylabel={ylabel}
        loading={loading}
        onClick={onClick}
        onUpdate={onUpdate}
        onRelayout={onRelayout}
        onInitialized={onInitialized}
        onAfterPlot={onAfterPlot}
        onLegendClick={onLegendClick}
        onLegendDoubleClick={onLegendDoubleClick}
        maxY={maxY}
        darkTheme={darkTheme}
        context={LINE_CHART_CONTEXT}
      />
      {aggregate && (
        <InfoPanel
          aggregate={aggregate}
          container={container.current}
          clickedFeature={clickedFeature}
          setClickedFeature={setClickedFeature}
        />
      )}
    </div>
  );
};

export default Plotly;
